import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FocusSelectOnDirective } from '../../../directives/focus-select.directive';
import { SanitizeCharsDirective } from '../../../directives/sanitize-chars.directive';
import { LetterCellEditorBaseComponent } from '../letter-cell-editor-base/letter-cell-editor-base.component';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'se-letter-cell-editor-inline',
    templateUrl: './letter-cell-editor-inline.component.html',
    styleUrls: ['./letter-cell-editor-inline.component.scss'],
    imports: [MatFormFieldModule, MatInputModule, ReactiveFormsModule, FocusSelectOnDirective, SanitizeCharsDirective],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LetterCellEditorInlineComponent extends LetterCellEditorBaseComponent {}
